import {$API} from "boot/api";
import {Loading, Notify} from "quasar";

export function startCompanyChat ({commit}, companyId) {
  Loading.show();
  $API.CHATS.POST({
    type: 'company',
    participants: [{
      id: companyId,
      type: 'company',
    }]
  }).then(({data}) => {
    commit('openMessenger', data.chat.id);
  }).catch(() => {
    Notify.create({
      message: 'Failed to start chat',
      color: 'negative',
      position: 'bottom',
    });
  }).finally(() => {
    Loading.hide();
  })
}
